import { gql } from '@apollo/client'

export const merchantAccountsFragment = gql`
	fragment merchantAccounts on Merchant {
		accounts {
			type
			balance {
				finalized {
					amountMCU
					code
					exponent
				}
				confirmed {
					amountMCU
					code
					exponent
				}
			}
		}
	}
`
export const merchantClassificationFragment = gql`
	fragment merchantClassification on Merchant {
		classification {
			id
			name
			child {
				id
				name
			}
		}
	}
`
